<template>
	<div class="task_cont">
		<SubHeader msg="任务管理模块" />
		<div class="cornerCut">
			<div class="task_box">
				<div class="task_box_top">
					<button class="creat_task" @click="creatVisible = true">创建任务</button>
					<div class="">
						<label>名称：</label>
						<input placeholder="请输入任务名称" />
						<label>类型：</label>
						<select>
							<option selected hidden disabled value="">请选择扫描类型</option>
							<option>11</option>
							<option>22</option>
						</select>
						<label>状态：</label>
						<select>
							<option selected hidden disabled value="">请选择任务状态</option>
							<option>11</option>
							<option>22</option>
						</select>
						<button class="seach_task">查询</button>
					</div>
				</div>
				
				<el-table
					:data="tableData.slice((currentPage-1)*pagesize,currentPage*pagesize)"
					stripe
					ref="multipleTable"
					tooltip-effect="dark"
					:header-row-class-name="header_style"
					:cell-class-nam="cell_style"
					:row-class-name="tableRowClassName"
					>
					<el-table-column prop="serial" label="序号" width=""></el-table-column>
					<el-table-column prop="date" label="任务名称" width=""></el-table-column>
					<el-table-column prop="name" label="任务类型" width=""></el-table-column>
					<el-table-column prop="name" label="创建时间" width=""></el-table-column>
					<el-table-column prop="name" label="运行时长" width=""></el-table-column>
					<el-table-column prop="name" label="创建者" width=""></el-table-column>
					<el-table-column prop="name" label="任务状态" width=""></el-table-column>
					<el-table-column prop="name" label="操作" width="300">
						<template slot-scope="scope">
							<el-button class="cz_btn btn_star" @click="handleClick(scope.row)">启动</el-button>
							<el-button class="cz_btn btn_stop" @click="handleClick(scope.row)">暂停</el-button>
							<el-button class="cz_btn btn_end" @click="handleClick(scope.row)">结束</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="address" label="任务监控">
						<template slot-scope="scope">
							<el-button class="jk_btn" @click="handleClick(scope.row)">任务监控</el-button>
						</template>
					</el-table-column>
				</el-table>
				<el-pagination
					 layout="total,jumper,prev, pager, next"
					 @current-change="current_change"
					 :total="total"
					 background
					>
				</el-pagination>
			</div>
		</div>
		<!--创建-->
		<el-dialog class="mk1_dialog" title="新建" :visible.sync="creatVisible" :modal="false">
			<CreatTask></CreatTask>
		</el-dialog>
	</div>
</template>

<script>
	import SubHeader from '../components/subHeader.vue'
	import CreatTask from '../components/creatTask.vue'
	export default {
		components: {
			SubHeader,
			CreatTask
		},
		data() {
			return {
				creatVisible:false,
				total:5,//默认数据总数
				pagesize:8,//每页的数据条数
				currentPage:1,//默认开始页面
				tableData: [{
						serial:'1',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					}, {
						serial:'2',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'3',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'4',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'5',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'6',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'7',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'8',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'9',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'10',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},{
						serial:'11',
						date: '电磁波扫描任务',
						name: '王小虎',
						address: '上海市普陀区金沙江路 1518 弄'
					},
				]
			}
		},
		mounted(){
			
		},
		created() {
			this.total=this.tableData.length;
		},
		methods:{
			handleClick(){
				
			},
			header_style({row,rowIndex}){
				return 'table-header'
			},
			cell_style({ row, column, rowIndex, columnIndex}) {
				if (columnIndex === 0 && row[column.property].indexOf('02') > -1) {
					// return 'background-color: #010f23'
				} else {
					return 'text-align: center'
				}
			},
			tableRowClassName({row, rowIndex}) {
				return '';
			},
			//分页方法
			tableRowClassName({row, rowIndex}) {
				if (rowIndex === 0) {
				  return 'th';
				}
				return '';
			},
			switchChange(){
				  this.istag = !this.istag ;
				  
			},
			current_change:function(currentPage){
				this.currentPage = currentPage;
			},
		}
	}
</script>

<style>
	.task_cont{display: block;overflow: hidden;width: 100vw;height: 100vh;background-image: url(../assets/home_bg.png);background-position: center top;background-repeat: no-repeat;background-size: 100% 100%;}
	
	.cornerCut{
		display: block;overflow: hidden;width: 98%;height: 88%;margin:0 auto;margin-top: 2%;
		background-image: url(../assets/table_bg.png);
		background-position: left top;
		/* background-color:#052b60;
		background:linear-gradient(-45deg,transparent 15px, #052b60 0) bottom right,
		linear-gradient(45deg,transparent 15px, #052b60 0) bottom left,
		linear-gradient(135deg,transparent 15px, #052b60 0) top left,
		linear-gradient(-135deg,transparent 15px,#052b60 0) top right;
		background-size: 50% 50%; */
		background-repeat: no-repeat;
		background-size: 100% 100%
	}
	.task_box{
		display: block;overflow: hidden;
		width: 97%;height: 90%;margin:0 auto;
		padding: 1.5%;overflow-y: auto;
		/* background-image: url(../assets/task_bg.png);
		background-position: center top;
		background-repeat: no-repeat;background-size: 100% 100%; */
	}
	.task_box_top{display: flex;justify-content: space-between; margin-bottom: 15px;}
	.task_box_top button{background-color: #19e8fc;border-radius: 4px;font-size: 18px;line-height: 36px;padding: 0px 20px;letter-spacing: 1px;color: #001738;}
	.task_box_top label{font-size: 18px;line-height: 36px;letter-spacing: 0px;color: #ffffff;}
	.task_box_top input,.task_box_top select{width: 10rem;margin-right: 30px;border-radius: 4px;border: solid 2px #1997ff;background-color: transparent;font-size: 14px;line-height: 36px;color: #ffffff;}
	.task_box_top select{height: 40px;}
	.task_box_top input{padding: 0 5px;}
	.creat_task{}
	.seach_task{}
	
	.task_box_table{width: 100%;}
	.task_box_table tr{text-align: center;height: 40px;}
	.task_box_table tr td{color: #FFFFFF;font-size: 14px;}
	
	.task_box_table tr:first-child{background-color: #124fa6!important;}
	.task_box_table tr:first-child td{color: #19e8fc!important;}
	.task_box_table tr:nth-child(even){background-color: #0a3b81;}
	.task_box_table tr:nth-child(odd){background-color: #010f23;}
	.cz_fun button{border-radius: 14px;color: #19e8fc;padding: 3px 13px;margin-right: 10px;background-color: #032a62;}
	.cz_fun button:nth-child(3){margin-right: 0px;}
	.jk_fun button{border-radius: 4px;color: #ffffff;padding: 3px 13px;background-color: #3278ff;}
	.on{color: #ffffff!important;background-color: #6021e4!important;}
	
	.pagediv{text-align: center;margin: 20px auto;}
	.pagetol{color: #ffffff;display: inline-block;/* float: left; */}
	.pagetol span{border: solid 1px #0a3b81;padding: 0px 5px;color: #ffffff;margin: 0 5px;}
	.pagelist{text-align: center;display: inline-block;}
	.pagelist li{background-color: #0e2341;border: solid 1px #0a3b81;padding: 2px 10px;display: inline-block;margin-right: 10px;color: #FFFFFF;}
	.act{background-color: #19e8fc!important;color: #001738!important;}
	
	
	.cz_btn{border-radius: 14px!important; padding:8px 13px!important; margin-right: 10px!important; background-color: #032a62!important;border: 0px!important;}
	.cz_btn span{ color: #19e8fc!important;}
	.cz_btn:focus{ background-color: #6021e4!important;}
	.cz_btn:focus span{ color: #ffffff!important;}
	.jk_btn{ border-radius: 4px!important; padding: 8px 13px!important;background-color: #3278ff!important;border: 0px!important;}
	.jk_btn span{ color: #ffffff!important;}
	.btn_star{}
	.btn_stop{}
	.btn_end{}

</style>
